import { squarediot } from "./proto-gen.js";

const v1 = squarediot.v1;

export function decodeHeartbeat(b64: string): squarediot.v1.IHeartbeat {
  return v1.Heartbeat.decode(base64ToBytes(b64));
}

export function decodeDeviceInfo(b64: string): squarediot.v1.IDeviceInfo {
  return v1.DeviceInfo.decode(base64ToBytes(b64));
}

export function decodeStatus(b64: string): squarediot.v1.IStatus {
  return v1.Status.decode(base64ToBytes(b64));
}

export function encodeSetActuator(pin: number, on: boolean): string {
  const cmd = v1.Command.create({
    setActuator: v1.SetActuatorCmd.create({ pin, on }),
  });
  return bytesToBase64(v1.Command.encode(cmd).finish());
}

export function encodeReboot(graceMs: number = 200): string {
  const cmd = v1.Command.create({
    reboot: v1.RebootCmd.create({ graceMs }),
  });
  return bytesToBase64(v1.Command.encode(cmd).finish());
}

function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

function bytesToBase64(b: Uint8Array): string {
  let s = "";
  for (let i = 0; i < b.length; i++) s += String.fromCharCode(b[i]);
  return btoa(s);
}
